








































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Job, JobStatus, JobCategory } from '@/models/job.interface';
import { Action, Getter } from 'vuex-class';
import Modal from '@/components/common/Modal.vue';
import { ModalOptions } from '@/models/modal.interface';
import { WorkflowStatus } from '@/models/util.interface';
import { Department } from '@/models/department.interface';
import { Country } from '../../models/country.interface';

@Component({ components: { Modal } })
export default class JobForm extends Vue {
  @Action('addJobAction') public addJobAction!: (payload: Job) => void;
  @Action('updateJobAction') public updateJobAction!: (payload: Job) => void;
  @Getter public jobWorkflowStatus!: WorkflowStatus;
  @Prop() private job!: Job;
  @Prop() private departments!: Department[];
  @Prop() private countries!: Country[];
  private jobForm!: Job;
  private isMissionDirty: boolean;
  private isProfileDirty: boolean;
  private departmentId: string;
  private countryName: string;

  get defaultCountry(): Country {
    return (this.countries || []).find((c: Country) => c.name === this.countryName) as Country;
  }

  constructor() {
    super();
    this.isMissionDirty = false;
    this.isProfileDirty = false;
    this.departmentId = '';
    this.countryName = 'France';
    this.initJob();
  }

  public mounted(): void {
    if (this.jobForm.location.department && this.jobForm.location.department._id) {
      this.departmentId = this.jobForm.location.department._id;
    }
    if (this.jobForm.location.country._id) {
      this.countryName = this.jobForm.location.country.name;
    }
  }

  public onDepartmentChanged(): void {
    if (this.departmentId) {
      this.jobForm.location.department = this.departments.find(
        (d: Department) => d._id === this.departmentId,
      ) as Department;
    } else {
      this.jobForm.location.department = null;
    }
  }

  public onCountryChanged(): void {
    if (this.countryName) {
      this.jobForm.location.country = this.defaultCountry;
    }
  }

  public async onSubmit(): Promise<void> {
    const isValid = await this.$validator.validate();
    if (isValid && this.isMissionValid() && this.isProfileValid()) {
      this.jobForm.location.country = !this.jobForm.location.country._id
        ? this.defaultCountry
        : this.jobForm.location.country;
      !this.jobForm._id ? this.addJobAction(this.jobForm) : this.updateJobAction(this.jobForm);
    }
  }

  private isMissionValid(): boolean {
    return this.jobForm.mission ? true : false;
  }

  private isProfileValid(): boolean {
    return this.jobForm.profile ? true : false;
  }

  private initJob(): void {
    this.jobForm = this.job
      ? { ...this.job }
      : {
          title: '',
          status: JobStatus.DRAFT,
          contractType: '',
          category: JobCategory.DEV,
          mission: '',
          profile: '',
          remuneration: '',
          startDate: '',
          keywords: [],
          location: {
            department: null,
            city: '',
            country: { _id: '', name: 'France', iso: 'fr' },
          },
        };
  }

  private missionChanged(value: string): void {
    this.jobForm.mission = value;
    this.isMissionDirty = true;
    this.$forceUpdate();
  }

  private profileChanged(value: string): void {
    this.jobForm.profile = value;
    this.isProfileDirty = true;
    this.$forceUpdate();
  }

  @Watch('jobWorkflowStatus')
  private onJobSaved(value: WorkflowStatus, oldValue: WorkflowStatus): void {
    if (value.add.success || value.update.success) {
      this.$notify({ text: `Offre d'emploi ${value.add.success ? 'créée' : 'modifiée'} avec succès`, type: 'success' });
      this.$router.push('/job/list');
    }
  }
}
